import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['catalogUrlField'];

  hidePublicCatalogUrlField() {
    this.catalogUrlFieldTarget.classList.add('d-none');
  }
}
